import { useRef, useState } from 'react'
import SwiperCore, { Navigation, Thumbs } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import { CTA, Container, HandLeftAltIcon, HandLeftIcon, HandRightIcon, Link, Logo, Title } from '~/components'
import { resizeImage } from '~/storyblok/resizeImage'
import { ImpressionStory } from '../types'

import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/thumbs/thumbs.min.css'
import 'swiper/swiper.min.css'

import * as styles from './Impression.css'

type Props = {
  story: ImpressionStory
}

SwiperCore.use([Navigation, Thumbs])

export function Impression({ story }: Props) {
  const [thumbsSwiper, setThumbsSwiper] = useState<any>(null)

  const navigationPrevRef = useRef<HTMLButtonElement>(null)
  const navigationNextRef = useRef<HTMLButtonElement>(null)

  const resizedMasterImages = story.content.gallery
    .map((image) => resizeImage(image, { width: 1920, height: 1080 }))
    .flatMap((image) => (image ? [image] : []))
  const resizedThumbsImages = story.content.gallery
    .map((image) => resizeImage(image, { width: 400, height: 300 }))
    .flatMap((image) => (image ? [image] : []))

  return (
    <div css={styles.wrapper}>
      <Container>
        <div css={styles.header}>
          <div css={styles.headerBrand}>
            <Link href="/">
              <Logo css={styles.logo} />
            </Link>
          </div>
          <div css={styles.headerAction}>
            <CTA href="/" icon={<HandLeftIcon css={styles.actionIcon} />}>
              zurück zur Übersicht
            </CTA>
          </div>
        </div>
      </Container>
      <div css={styles.title}>
        <Container>
          <Title label="Impressionen">{story.content.title}</Title>
        </Container>
      </div>

      <div css={styles.slider}>
        <div css={styles.arrows}>
          <div css={styles.arrowsContent}>
            <button ref={navigationPrevRef} css={styles.arrowButton}>
              <HandLeftAltIcon css={styles.arrowIcon} />
            </button>
            <button ref={navigationNextRef} css={styles.arrowButton}>
              <HandRightIcon css={styles.arrowIcon} />
            </button>
          </div>
        </div>

        <Swiper
          breakpoints={{
            1024: {
              spaceBetween: 40,
            },
          }}
          spaceBetween={20}
          thumbs={{ swiper: thumbsSwiper }}
          navigation={{
            prevEl: navigationPrevRef.current,
            nextEl: navigationNextRef.current,
          }}
          onBeforeInit={(swiper: any) => {
            swiper.params.navigation.prevEl = navigationPrevRef.current
            swiper.params.navigation.nextEl = navigationNextRef.current
          }}
          className="swiperMaster"
        >
          {resizedMasterImages.map((image) => (
            <SwiperSlide key={image.id}>
              <img src={image.url} alt="" css={styles.masterImage} />
            </SwiperSlide>
          ))}
        </Swiper>
        <Swiper
          onSwiper={setThumbsSwiper}
          breakpoints={{
            540: {
              slidesPerView: 5,
            },
            1024: {
              spaceBetween: 40,
              slidesPerView: 5,
            },
          }}
          spaceBetween={20}
          slidesPerView={3}
          freeMode={true}
          watchSlidesProgress={true}
          className="swiperThumbs"
        >
          {resizedThumbsImages.map((image) => (
            <SwiperSlide key={image.id}>
              <img src={image.url} alt="" css={styles.thumbImage} />
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </div>
  )
}
